"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _TextField = _interopRequireDefault(require("../../atoms/TextField"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getWidth = function getWidth(_ref) {
  var fullWidth = _ref.fullWidth,
      theme = _ref.theme,
      width = _ref.width;
  return fullWidth ? '100%' : theme.typography.pxToRem(width);
};

var buildChipStyles = function buildChipStyles(_ref2) {
  var _ref2$theme = _ref2.theme,
      pxToRem = _ref2$theme.typography.pxToRem,
      grey = _ref2$theme.palette.grey;
  return (0, _styledComponents.css)(["border-radius:", ";margin:", ";background-color:", ";max-width:-webkit-fill-available;&:hover{background-color:", ";}&:active{background-color:", ";}&:disabled{background-color:", ";}"], pxToRem(8), pxToRem(8), grey[200], grey[400], grey[500], grey[100]);
};

var Chips = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "Tags__Chips"
})(["background-color:", ";width:", ";"], function (props) {
  return props.theme.palette.grey[50];
}, function (props) {
  return getWidth(props);
});

var Chip = /*#__PURE__*/(0, _styledComponents["default"])(_Chip["default"]).withConfig({
  displayName: "Tags__Chip"
})(["", ""], buildChipStyles);
var TextField = /*#__PURE__*/(0, _styledComponents["default"])(_TextField["default"]).withConfig({
  displayName: "Tags__TextField"
})(["width:", ";.MuiInputAdornment-root{padding-bottom:", ";}"], function (props) {
  return getWidth(props);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.pxToRem(12);
});
var Autocomplete = /*#__PURE__*/(0, _styledComponents["default"])(_Autocomplete["default"]).withConfig({
  displayName: "Tags__Autocomplete"
})([".MuiAutocomplete-inputRoot{padding-left:", ";padding-right:0;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.pxToRem(8);
});

var defaultGetOptionLabel = function defaultGetOptionLabel(option) {
  return typeof option === 'string' ? option : option.title;
};

var Tags = function Tags(_ref5) {
  var chipsDeletable = _ref5.chipsDeletable,
      chipsSize = _ref5.chipsSize,
      chipsDisabled = _ref5.chipsDisabled,
      onChipAdd = _ref5.onChipAdd,
      onChipDelete = _ref5.onChipDelete,
      onUpdate = _ref5.onUpdate,
      width = _ref5.width,
      fullWidth = _ref5.fullWidth,
      label = _ref5.label,
      placeholder = _ref5.placeholder,
      minCharsToShowOptions = _ref5.minCharsToShowOptions,
      props = _objectWithoutProperties(_ref5, ["chipsDeletable", "chipsSize", "chipsDisabled", "onChipAdd", "onChipDelete", "onUpdate", "width", "fullWidth", "label", "placeholder", "minCharsToShowOptions"]);

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      currentOptions = _useState2[0],
      setCurrentOptions = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      chips = _useState4[0],
      setChips = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1]; // callbacks and memos


  var handleChipAdd = (0, _react.useCallback)(function (callback) {
    setChips(chips.indexOf(inputValue) < 0 ? chips.concat([inputValue]) : chips);
    callback && callback(inputValue); // empty and reload it when adding next tag (after typing two characters)

    setInputValue('');
    setCurrentOptions([]);
  }, [chips, inputValue]);
  var handleChipDelete = (0, _react.useCallback)(function (chipToDelete, callback) {
    return function () {
      setChips(function (chips) {
        return chips.filter(function (chip) {
          return chip !== chipToDelete;
        });
      });
      callback && callback(chipToDelete);
    };
  }, []);
  var handleInputChange = (0, _react.useCallback)(function (e, inputValue) {
    setInputValue(inputValue);

    if (inputValue.length >= minCharsToShowOptions) {
      setCurrentOptions(props.options);
    } else {
      setCurrentOptions([]);
    }
  }, [inputValue, props.options]);
  var onKeyPress = (0, _react.useCallback)(function (e) {
    if (e.key === 'Enter' && inputValue.length > 0) {
      handleChipAdd(onChipAdd);
    }
  }, [inputValue, onChipAdd, handleChipAdd]);
  var onClick = (0, _react.useCallback)(function () {
    return handleChipAdd(onChipAdd);
  }, [onChipAdd, handleChipAdd]);
  var renderEndAdornment = (0, _react.useMemo)(function () {
    return _react["default"].createElement(_InputAdornment["default"], {
      position: "end"
    }, _react["default"].createElement(_IconButton["default"], {
      onClick: onClick,
      icon: "plus",
      disabled: inputValue.length === 0
    }));
  }, [inputValue, onClick]);
  var renderTextField = (0, _react.useCallback)(function (params) {
    return _react["default"].createElement(TextField, _extends({}, params, {
      label: label,
      placeholder: placeholder,
      fullWidth: fullWidth,
      width: width,
      onKeyPress: onKeyPress,
      InputProps: _objectSpread({}, params.InputProps, {
        endAdornment: renderEndAdornment
      })
    }));
  }, [label, placeholder, fullWidth, width, inputValue, onChipAdd]);
  var renderInput = (0, _react.useCallback)(function (params) {
    return renderTextField(params);
  }, [renderTextField]);
  (0, _react.useEffect)(function () {
    onUpdate && onUpdate(chips);
  }, [chips, onUpdate]);
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(Autocomplete, _extends({}, props, {
    autoComplete: true,
    freeSolo: true,
    inputValue: inputValue,
    options: currentOptions,
    onInputChange: handleInputChange,
    getOptionLabel: props.getOptionLabel,
    renderInput: renderInput
  })), _react["default"].createElement(Chips, {
    width: width,
    fullWidth: fullWidth
  }, chips.map(function (data) {
    return _react["default"].createElement(Chip, {
      clickable: true,
      onDelete: chipsDeletable ? handleChipDelete(data, onChipDelete) : null,
      key: data,
      label: data,
      disabled: chipsDisabled,
      size: chipsSize
    });
  })));
};

Tags.defaultProps = {
  // autocomplete
  clearOnEscape: true,
  getOptionLabel: defaultGetOptionLabel,
  options: [],
  disableOpenOnFocus: true,
  disableCloseOnSelect: false,
  disabled: false,
  // textfield
  fullWidth: false,
  label: 'Add Tag',
  placeholder: 'Add Tag',
  width: 320,
  minCharsToShowOptions: 2,
  // chips
  chipsDeletable: true,
  chipsDisabled: false,
  chipsSize: 'medium',
  onChipDelete: function onChipDelete() {},
  onChipAdd: function onChipAdd() {},
  onUpdate: function onUpdate() {}
};
Tags.propTypes = {
  // autocomplete
  clearOnEscape: _propTypes["default"].bool,
  getOptionLabel: _propTypes["default"].func,
  options: _propTypes["default"].array,
  disableOpenOnFocus: _propTypes["default"].bool,
  disableCloseOnSelect: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  // textfield
  fullWidth: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  width: _propTypes["default"].number,
  minCharsToShowOptions: _propTypes["default"].number,
  // chips
  chipsDeletable: _propTypes["default"].bool,
  chipsDisabled: _propTypes["default"].bool,
  chipsSize: _propTypes["default"].string,
  onChipDelete: _propTypes["default"].func,
  onChipAdd: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func
};

var _default = (0, _styles["default"])(Tags);

exports["default"] = _default;